module.exports = __webpack_public_path__ + "img/KN.dc7524f2.svg";